class LspFormFieldDirective {
  constructor() {
    this.restrict = 'A';
    this.require = 'ngModel';
    this.bindToController = 'true';
    this.controllerAs = 'ctrl';
  }

  link(scope, element, attrs, modelCtrl) {
    this.onFocus(element, modelCtrl);
    this.onBlur(element, modelCtrl, scope);

    if (modelCtrl.$$parentForm && modelCtrl.$$parentForm.showValidation === undefined) {
      modelCtrl.$$parentForm.showValidation = function showValidation(field) {
        return field && (((field.$$parentForm.$submitted || field.$submitted) && field.$pristine) || field.$touched);
      };
    }
  }

  onBlur(element, modelCtrl, scope) {
    element.bind('blur', (e) => {
      if (!modelCtrl.$pristine || !modelCtrl.$valid || modelCtrl.$$parentForm.$submitted) {
        modelCtrl.$validate();
      } else {
        e.preventDefault();
        e.stopImmediatePropagation();
        modelCtrl.$setUntouched();
        scope.$digest();
      }
    });
  }

  onFocus(element, modelCtrl) {
    element.bind('focus', () => {
      if (!modelCtrl.$pristine || modelCtrl.$$parentForm.$submitted) {
        for (const key of Object.keys(modelCtrl.$error)) {
          modelCtrl.$setValidity(key, true);
        }
        modelCtrl.$setUntouched();
      }
    });
  }
}

export default LspFormFieldDirective;



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-validators/lsp-form-field-validator/lsp-form-field-directive.js